import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { setAuthContextRef } from '../utils/httpInterceptor';
import { useAuth } from '../contexts/AuthContext';

interface AuthProviderWrapperProps {
  children: React.ReactNode;
}

const AuthProviderWrapper: React.FC<AuthProviderWrapperProps> = ({ children }) => {
  const { logout } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    setAuthContextRef({ logout, navigate });
  }, [logout, navigate]);

  return <>{children}</>;
};

export default AuthProviderWrapper;
